import React from 'react';
import { ArrowDownIcon, CheckCircle2Icon, XCircleIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { afterItems, beforeItems } from '../data/content';
export function BeforeAfter() {
  return <section className="bg-white py-16 sm:py-24" aria-labelledby="before-after-title" data-id="element-45" data-mp="3oezpxm3x7lc3">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-46" data-mp="3sgbjg2px0qpk">
        <h2 id="before-after-title" className="text-center font-serif text-[32px] font-extrabold leading-tight text-ink sm:text-5xl" data-id="element-47" data-mp="3sj7f1keaj3au">
          Stop looking at CBCTs <em className="text-brand-600" data-id="element-48" data-mp="3jiri6ts1yuey">without a system</em>
        </h2>

        <div className="mt-10 grid items-stretch gap-4 md:grid-cols-[1fr_auto_1fr] md:gap-6" data-id="element-49" data-mp="34td6vg4x22wx">
          <div className="rounded-3xl border-2 border-red-100 bg-red-50/60 p-6 sm:p-8" data-id="element-50" data-mp="39rn3lv6ahbkn">
            <p className="inline-flex rounded-full bg-alert px-3 py-1 text-xs font-extrabold uppercase tracking-wider text-white" data-id="element-51" data-mp="2vs59r1e4z84f">
              Before
            </p>
            <h3 className="mt-3 font-serif text-2xl font-bold text-ink" data-id="element-52" data-mp="x4ac78baliz0">From…</h3>
            <ul className="mt-5 space-y-4" data-id="element-53" data-mp="x6emq93p5g89">
              {beforeItems.map(item => <li key={item} className="flex gap-3 text-[17px] leading-snug text-ink" data-id="element-54" data-mp="t5b9zvgy40b9">
                  <XCircleIcon className="mt-0.5 h-6 w-6 shrink-0 text-alert" aria-hidden="true" data-id="element-55" data-mp="170nfmxwn3b6y" />
                  <span data-id="element-56" data-mp="121k9tb8u50xx">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="flex items-center justify-center" aria-hidden="true" data-id="element-57" data-mp="ebzr8tglg5p6">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-brand-700 text-white shadow-lg md:-rotate-90" data-id="element-58" data-mp="9gkb1uv45xpl">
              <ArrowDownIcon className="h-6 w-6" data-id="element-59" data-mp="jd5kcse61uz8" />
            </span>
          </div>

          <div className="rounded-3xl bg-brand-800 p-6 text-white shadow-xl sm:p-8" data-id="element-60" data-mp="jbcbr7jzt0ol">
            <p className="inline-flex rounded-full bg-cta px-3 py-1 text-xs font-extrabold uppercase tracking-wider text-white" data-id="element-61" data-mp="3rr4b9fma6q5v">
              After
            </p>
            <h3 className="mt-3 font-serif text-2xl font-bold" data-id="element-62" data-mp="1qpofu5vk4tlj">To…</h3>
            <ul className="mt-5 space-y-4" data-id="element-63" data-mp="1vpkju5498l13">
              {afterItems.map(item => <li key={item} className="flex gap-3 text-[17px] leading-snug" data-id="element-64" data-mp="20giyz1dibd2r">
                  <CheckCircle2Icon className="mt-0.5 h-6 w-6 shrink-0 text-green-400" aria-hidden="true" data-id="element-65" data-mp="20inc89xapofp" />
                  <span data-id="element-66" data-mp="24jyyq6kvhtjo">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <CtaButton className="mt-12" label="Yes, I want a system for every CBCT" data-id="element-67" data-mp="1cqonan4xbuk3" />
      </div>
    </section>;
}